export const COMPATIBLE_APP_VERSION = '0.6.30';
